module.exports = __webpack_public_path__ + "img/logo_groot33.138a05b3.png";